// Module
var code = "<a data-ng-click=documentPreviewButtonVm.showDocumentPreviewDialog(documentPreviewButtonVm)> <i data-ng-if=!documentPreviewButtonVm.icon class=\"zmdi zmdi-search-in-file\"></i> <span data-ng-transclude></span> </a> ";
// Exports
module.exports = code;